import React from "react";
import "./index.less";
import SlfwLogo from "../../assets/images/slLogo.png";
import {
    Row,
    Col,
    Tooltip,
    Button
} from "antd";
import HPC from "../../assets/images/hpc.png";
import YWD from "../../assets/images/ywd.png";


function Slfw() {

    const data = [{
        name: "启真一号HPC",
        tag: "按量计费",
        type: "CPU",
        des: "由西湖之光联盟成员提供一套HPC超算调度集群，共有10024个核心；提供slurm调度器按量计费服务。",
        jg: "0.05",
        icon: HPC,
        jgType: "核时"
    }, {
        name: "星河超算HPC",
        tag: "按量计费",
        type: "CPU",
        des: "由信息技术中心与物理学院-星河超算合作，纳管其中7台2T胖节点；提供slurm调度器和容器化按量计费服务。",
        jg: "0.08",
        icon: HPC,
        jgType: "核时"
    }, {
        name: "NVIDIA V100 / 32G",
        tag: "按量计费",
        type: "GPU",
        des: "由信息技术中心与CAD&CG全重实验室合作共建400张V100集群；提供slurm调度器和容器化按量计费服务。",
        jg: "1.5",
        icon: YWD,
        jgType: "卡时"
    }, {
        name: "NVIDIA 4090D / 24G",
        tag: "按量计费",
        type: "GPU",
        des: "由信息技术中心自建24张4090D集群；提供slurm调度器和容器化按量计费服务。",
        jg: "1.5",
        icon: YWD,
        jgType: "卡时"
    }, {
        name: "NVIDIA 5090 / 32G",
        tag: "按量计费",
        type: "GPU",
        des: "由信息技术中心自建16张5090集群；提供容器化按量计费服务。",
        jg: "2.35",
        icon: YWD,
        jgType: "卡时"
    }, {
        name: "NVIDIA 4090 / 24G",
        tag: "按量计费",
        type: "GPU",
        des: "由西湖之光联盟成员提供的4090计算卡；提供容器化按量计费服务。",
        jg: "1.79",
        icon: YWD,
        jgType: "卡时"
    }, , {
        name: "NVIDIA 4090 / 24G",
        tag: "按量计费",
        type: "GPU",
        des: "由西湖之光联盟成员提供的4090计算卡；提供容器化按量计费服务。",
        jg: "1.79",
        icon: YWD,
        jgType: "卡时"
    }, , {
        name: "RTX 4090D 1/2/4/8卡",
        tag: "包年包月",
        type: "GPU",
        des: "由信息技术中心自建24张4090D集群；提供1/2/4/8卡虚拟机包年包月租赁服务。",
        jg: "860",
        icon: YWD,
        jgType: "月"
    }, , {
        name: "RTX 5090 1/2/4/8卡",
        tag: "按量计费",
        type: "GPU",
        des: "由信息技术中心自建16张5090集群；提供1/2/4/8卡虚拟机包年包月租赁服务。",
        jg: "1350",
        icon: YWD,
        jgType: "月"
    },]

    return <div className="slfw">
        <div className="warpContent">


            <div className="logoCotent">
                <div className="logo">
                    <div className="img">
                        <img src={SlfwLogo} />
                    </div>

                </div>
                <div className="description">
                    启真算力中心主要面向全校提供高性能科学计算服务，满足各学科领域对于大规模数据处理、科学计算及大模型训练推理的需求。平台的主要任务是提供统一算力资源、高水平稳定的算力平台、专业可持续的技术运维服务、丰富全面的软件资源、普惠的定价体系、合理的收费机制和资源分配，实现“数字化运营、高效协作、众筹共享、合作共赢”的高校科研众筹模式。
                </div>

            </div>
            <div style={{
                width: "100%",
                padding: "10px 0",
                textAlign: "right"
            }}><Button type="primary" target="_blank" onClick={() => {
                window.open("https://hpc.zju.edu.cn/welcome")
            }} >{"了解详情>>"}</Button></div>
            <div className="content">

                <Row gutter={[16, 16]}>
                    {
                        data.map((item) => {
                            return <Col span={8}>
                                <div className="product-item">
                                    <div className="item-top">
                                        <img src={item.icon} alt="" />
                                        <div className="top-content">
                                            <div className="pro-title ellipsis1">{item.name}</div>
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "flex-start",
                                                paddingLeft: "15px"
                                            }}>
                                                <div className="charge-type">{item.tag}</div>
                                                <div className="pro-types" >
                                                    <div>
                                                        <span>资源类型：</span>{item.type}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="pro-des ellipsis2">{item.des}</div>
                                    <div className="pro-list">
                                        <div className="item">
                                            <span>¥{item.jg}起</span>
                                            <span>元/{item.jgType}</span>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        })
                    }
                </Row>
            </div>
        </div>
    </div >
}

export default Slfw